













































import Vue from 'vue';
import TopBar from '@/components/widgets/TopBar.vue';
import InventoryPlacement from '@/components/publisher/InventoryPlacement.vue';
import Button from '@/components/form/Button.vue';
import filterParams from '@/components/table/utils/filterParameters';
import { mapGetters } from 'vuex';
import Preloader from '@/components/preloader/Preloader.vue';

export default Vue.extend({
  name: 'PlacementForm',
  components: { Preloader, TopBar, InventoryPlacement, Button },
  props: {
    id: {
      required: true,
    },
  },
  async mounted() {
    this.loadData = true;
    await Promise.all([
      this.$store.commit(
        'changeTitle',
        this.$t('pages.inventoryForm.blocks.createPlacement.blockName')
      ),
      this.$store.dispatch('publisher/inventory', {
        id: this.id,
        expand: 'languages,categories,placements',
      }),
      this.$store.dispatch('categories'),
    ]);
    this.loadData = false;
  },
  computed: {
    routerBack() {
      return filterParams.getUrlBack() || '';
    },
    title(): string {
      return (
        this.$t('pages.inventory.title') + ' ' + (this.inventory?.name || '#1')
      );
    },
    ...mapGetters({
      inventory: 'publisher/getInventory',
      category: 'categoryList',
      readyToSave: 'hasValidationErrors',
      isSavingForm: 'publisher/getIsSavingForm',
    }),
  },
  methods: {
    submitForm() {
      this.$store.dispatch('publisher/submitForm', {
        APIName: 'updateInventory',
        inventoryId: this.id,
      });
    },
    closeForm() {
      this.$router.push(this.routerBack);
    },
  },
  data() {
    return {
      loadData: false,
    };
  },
});
